module.exports = __webpack_public_path__ + "img/designs-717.bb04198.png";